(function () {
  function initStudio(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const viewport = root.querySelector('.bw-studio-viewport');
    const scene = root.querySelector('[data-scene]');
    const preview = root.querySelector('.bw-studio-preview');

    const wallElements = root.querySelectorAll('[data-wall]');
    const ceilingElements = root.querySelectorAll('[data-ceiling]');
    const furniture = root.querySelector('[data-furniture]');

    const zoomLabel = root.querySelector('[data-zoom-label]');

    const defaults = {
      wall: '#F4EDE3',
      ceiling: '#FFFFFF',
      room: 'nursery',
      mode: 'empty'
    };

    let zoom = 1;

    function setColor(type, color) {
      const elements = type === 'wall' ? wallElements : ceilingElements;
      const group = root.querySelector(
        type === 'wall' ? '[data-wall-colors]' : '[data-ceiling-colors]'
      );

      elements.forEach(function (el) {
        el.setAttribute('fill', color);
      });

      group.querySelectorAll('[data-color]').forEach(function (button) {
        const selected = button.dataset.color.toLowerCase() === color.toLowerCase();
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      const picker = root.querySelector(
        type === 'wall' ? '[data-wall-picker]' : '[data-ceiling-picker]'
      );

      picker.value = color;
    }

    function setMode(mode) {
      furniture.hidden = mode !== 'furnished';
      furniture.style.display = mode === 'furnished' ? '' : 'none';

      root.querySelectorAll('[data-mode]').forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.mode === mode);
      });
    }

    function setRoom(room) {
      root.dataset.room = room;

      root.querySelectorAll('[data-room]').forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.room === room);
      });
    }

    function setZoom(value) {
      zoom = Math.min(2.5, Math.max(1, value));

      scene.style.width = (zoom * 100) + '%';
      zoomLabel.textContent = Math.round(zoom * 100) + '%';
    }

    root.querySelectorAll('[data-wall-colors] [data-color]').forEach(function (button) {
      button.addEventListener('click', function () {
        setColor('wall', button.dataset.color);
      });
    });

    root.querySelectorAll('[data-ceiling-colors] [data-color]').forEach(function (button) {
      button.addEventListener('click', function () {
        setColor('ceiling', button.dataset.color);
      });
    });

    root.querySelector('[data-wall-picker]').addEventListener('input', function (event) {
      setColor('wall', event.target.value);
    });

    root.querySelector('[data-ceiling-picker]').addEventListener('input', function (event) {
      setColor('ceiling', event.target.value);
    });

    root.querySelectorAll('[data-mode]').forEach(function (button) {
      button.addEventListener('click', function () {
        setMode(button.dataset.mode);
      });
    });

    root.querySelectorAll('[data-room]').forEach(function (button) {
      button.addEventListener('click', function () {
        setRoom(button.dataset.room);
      });
    });

    root.querySelector('[data-zoom-in]').addEventListener('click', function () {
      setZoom(zoom + 0.25);
    });

    root.querySelector('[data-zoom-out]').addEventListener('click', function () {
      setZoom(zoom - 0.25);
    });

    root.querySelector('[data-fit]').addEventListener('click', function () {
      setZoom(1);
      viewport.scrollTop = 0;
      viewport.scrollLeft = 0;
    });

    root.querySelector('[data-fullscreen]').addEventListener('click', function () {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else if (preview.requestFullscreen) {
        preview.requestFullscreen().catch(function () {
          // Fullscreen may be unsupported.
        });
      }
    });

    root.querySelector('[data-reset]').addEventListener('click', function () {
      setColor('wall', defaults.wall);
      setColor('ceiling', defaults.ceiling);
      setMode(defaults.mode);
      setRoom(defaults.room);
      setZoom(1);
    });

    setColor('wall', defaults.wall);
    setColor('ceiling', defaults.ceiling);
    setMode(defaults.mode);
    setRoom(defaults.room);
    setZoom(1);
  }

  function initAll() {
    document.querySelectorAll('.bw-studio').forEach(initStudio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();